import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// Site::Lp01::FloatingCta::Component の Stimulus コントローラ。
// landIeul: 800px スクロールで Lp01_fadeIn を付与。
const SCROLL_TARGET_OFFSET = 800;

class SiteLp01FloatingCtaController extends Controller {
  private handler = () => this.onScroll();

  connect(): void {
    window.addEventListener("scroll", this.handler);
    this.onScroll();
  }

  disconnect(): void {
    window.removeEventListener("scroll", this.handler);
  }

  private onScroll(): void {
    this.element.classList.toggle(
      "Lp01_fadeIn",
      window.pageYOffset > SCROLL_TARGET_OFFSET,
    );
  }
}

application.register("site--lp01--floating-cta", SiteLp01FloatingCtaController);
